import { IUserState } from '../../types/redux/user';

const initialState: IUserState = {
  userId: null,
};

export function userReducer(state: IUserState = initialState): IUserState {
  return state;
}
